import { Component, input, signal, ViewEncapsulation, WritableSignal, OnInit, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { DialogModule  } from 'primeng/dialog';
import {ModalSettingsComponent} from '../modal-settings/modal-settings.component'
import { SharedDataService } from '../../services/componentsServices/shared-data.service';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { UserProfileStore } from '../../store/user-profile.store';
import { PermissionService } from '../../services/security/permission.service';


@Component({
    selector: 'app-cvx-navbar',
    imports: [CommonModule, MenubarModule, FontAwesomeModule, DialogModule, ModalSettingsComponent],
    templateUrl: './cvx-navbar.component.html',
    styleUrl: './cvx-navbar.component.scss'
})
export class CvxNavbarComponent {
    public faGear = faGear;
    public faUsers = faUsers;
    public faSpinner = faSpinner;
    // pMenuItems = input<MenuItem[] | undefined>([]);
    isModalOpen = signal(false);
    private userProfileStore = inject(UserProfileStore);
    private permission = inject(PermissionService);
    readonly canOpenSettings = computed(() => this.permission.canOpenSettings());

    constructor(private SharedDataService: SharedDataService){}

    get dropdownsLoading(): boolean {
        return this.SharedDataService.getDropdownsLoading();
    }


    openSettingsModal(){
    if (!this.canOpenSettings()) {
            return; 
        }
        if(this.SharedDataService.getDropdownsLoading()){
            return; // ignore clicks while loading dropdowns
        }
        this.isModalOpen.set(true);
      }

    closeModal(){
        this.isModalOpen.set(false);
    }
}
